import { schema } from 'normalizr';

import workCategory from './workCategory';

const workCategoryGroup = new schema.Entity('workCategoryGroup', {
  workCategories: [workCategory],
});

export default workCategoryGroup;
